import moment from "moment";
// import { useContext } from 'react'
import userTypes from "venuescanner-js/constants/user_type";
// import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
export const transposeMessageContent = ({
  activeUser,
  message,
  showDataFor,
}) => {
  // const { activeUser } = useContext(ViewContext)
  let successful = false;
  let text = message.msg;
  let callDuration = null;
  if (message.msg.match(/^callFeedback/)) {
    const [tag, status, from, when, duration] = message.msg.split(",");
    const calledWhen = moment(when, "HH:mm DD/MM/YY").fromNow();
    const { from_name, from_type, from: fromUserId } = message;
    const fromActiveUser = activeUser._subjects._value._id === fromUserId;
    // console.log(showDataFor, activeUser._id, fromUserId)
    const msg = [];
    if (showDataFor === userTypes.host) {
      if (from_type === userTypes.host) {
        if (fromActiveUser) {
          msg.push(`You called the Organiser`);
        } else {
          msg.push(`${from_name} called the Organiser`);
        }
      } else if (from_type === userTypes.organiser) {
        msg.push(`${from_name} the Organiser called`);
      }
    } else if (showDataFor === userTypes.organiser) {
      if (from_type === userTypes.organiser) {
        msg.push(`You called the Venue`);
      } else if (from_type === userTypes.host) {
        msg.push(`${from_name} called You`);
      }
    }
    msg.push(` ${calledWhen}`);
    switch (status) {
      case "failed":
        successful = false;
        msg.push(", but it failed to connect");
        break;
      case "no-answer":
        successful = false;
        if (fromActiveUser) {
          msg.push(", but they did not pick up");
        } else {
          if (from_type === userTypes.host) {
            msg.push(", but they did not pick up");
          } else {
            msg.push(", but you did not pick up");
          }
        }
        break;
      case "completed":
        successful = true;
        msg.push(` which lasted ${duration}s`);
        break;
      default:
        successful = false;
        msg.push(", but it failed to connect");
        break;
    }
    if (msg.length) text = msg.join("");
  }
  return [successful, text];
};
